/**
 * API Reference Pagination page content.
 *
 * Explains cursor-based pagination used across all list endpoints.
 */

export const apiPaginationContent = `
All list endpoints use cursor-based pagination and return a standard envelope:

\`\`\`json
{
  "data": [...],
  "has_more": true
}
\`\`\`

## Parameters

Every list endpoint accepts these pagination parameters:

| Parameter | Type | Description |
|-----------|------|-------------|
| limit | int | Max results per page (1\u2013100, default 20) |
| starting_after | int | Cursor: ID of the last item from the previous page |

## Fetching the Next Page

Pass the last item\u2019s ID as \`starting_after\` to fetch the next page. When \`has_more\` is \`false\`, there are no more results.

\`\`\`bash
# First page
curl https://m8tes.ai/api/v2/teammates?limit=10 \\
  -H "Authorization: Bearer m8_your_key_here"

# Next page (using last item's ID)
curl https://m8tes.ai/api/v2/teammates?limit=10&starting_after=15 \\
  -H "Authorization: Bearer m8_your_key_here"
\`\`\`

\`\`\`python
page = client.teammates.list(limit=10)
for teammate in page.data:
    print(teammate.name)

# Fetch next page
if page.has_more:
    next_page = client.teammates.list(limit=10, starting_after=page.data[-1].id)
\`\`\`

## Supported Endpoints

All list endpoints support pagination:

- \`GET /teammates\`
- \`GET /runs\`
- \`GET /tasks\`
- \`GET /webhooks\`
- \`GET /memories\`
- \`GET /permissions\`
- \`GET /apps\`
`;
